import { render, staticRenderFns } from "./ChartItem.vue?vue&type=template&id=16872586&scoped=true&"
import script from "./ChartItem.vue?vue&type=script&lang=js&"
export * from "./ChartItem.vue?vue&type=script&lang=js&"
import style0 from "./ChartItem.vue?vue&type=style&index=0&id=16872586&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16872586",
  null
  
)

export default component.exports